import { AssetProgressDto } from "@core/typesV2";
import { ActivityProgressService } from "@servicesV2";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { useService } from "./useService";

export type UseAssetProgressQueryParams = {
  courseId: string;
  activityId?: string;
  learnerId?: string;
  enabled?: boolean;
};

export function useAssetProgressQuery(
  {
    courseId,
    activityId,
    learnerId,
    enabled = true,
  }: UseAssetProgressQueryParams,
  options?: Omit<UseQueryOptions<AssetProgressDto[]>, "queryKey" | "queryFn">,
) {
  const { initialization: activityProgressServiceInit } = useService(
    ActivityProgressService,
  );

  return useQuery({
    ...options,
    queryKey: [
      "assets",
      "progress",
      { courseId, activityId, learnerId: learnerId || null },
    ],
    enabled: !!activityId && !!enabled,
    queryFn: async () => {
      const { service: activityProgressService } =
        await activityProgressServiceInit;

      return activityProgressService.getAssetProgress(
        courseId,
        activityId!,
        learnerId,
      );
    },
  });
}
